import React, { useEffect, useState } from 'react'
import Api from '../../../../Api';
import './Raffle.scss';
import RaffleSoon from './RaffleSoon';
import Winners from './Winners';

const Raffle = () => {
    const [winningsList, setWinningsList] = useState([]);

    const fetchWinners = () => {
        Api.GET_WINNERS_LIST().then(({data: {winings_list}}) => {
            setWinningsList(winings_list);
        })
    }

    useEffect(() => {
        fetchWinners();
    }, []);

    return (
        <div id="results" className="raffle-component">
            <div className="raffle-component__container">
                {winningsList?.length > 0 ? <Winners winnersList={winningsList} /> : <RaffleSoon />}
            </div>
        </div>
    )
}


export default Raffle;